var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import formTheme from '../../theme';
import { ComponentThemeProvider } from '../../../ThemeProvider';
var HintWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 0.75rem;\n  ", "\n"], ["\n  font-size: 0.75rem;\n  ",
    "\n"])), function (_a) {
    var component = _a.theme.component, disabled = _a.disabled;
    return disabled && "color: " + component.form.textColor.disabled;
});
/**
 * Input hint that can be used to provide further information
 */
var InputHint = function (props) {
    var disabled = props.disabled, message = props.message;
    return (React.createElement(ComponentThemeProvider, { theme: formTheme },
        React.createElement(HintWrapper, { "data-testid": "input-hint", disabled: Boolean(disabled) }, message)));
};
export default InputHint;
var templateObject_1;
//# sourceMappingURL=index.js.map